// Types to construct refine filter groups
export enum RefineGroupKeyType {
  FilterByType = 'filterByType',
  SloFilters = 'sloFilters',
  SloGroupFilters = 'sloGroupFilters',
  CapabilityFilters = 'capabilityFilters',
}

export enum FilterByTypeType {
  BySlo = 'bySlo',
  BySloGroup = 'bySloGroup',
  ByCapability = 'byCapability',
  ByTeam = 'byTeam',
  ByProduct = 'byProduct',
}

export enum SloGroupFiltersType {
  MimirOnly = 'mimirOnly',
}

export enum SloFiltersType {
  BreachingOnly = 'breachingOnly',
  DraftOnly = 'draftOnly',
}

export enum CapabilityFiltersType {
  WithSloBreachOnly = 'withSloBreachOnly',
  WithNoSloOnly = 'withNoSloOnly',
}

export type RefineGroupType = {
  label: string;
  key: string;
  options: RefineOptionType[];
};

export type RefineOptionType = {
  label: string;
  key: RefineOptionKeyType;
  options?: RefineOptionType[];
  helperCopyPath?: string;
};

export type RefineOptionKeyType =
  | FilterByTypeType
  | SloFiltersType
  | CapabilityFiltersType
  | SloGroupFiltersType;
export type URLObjectType = { [key in RefineOptionKeyType | 'page' | 'query']: string };
